import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CrmFormComponent, CrmFormProvider } from '@touch4it/ng-swp/form';

import { DetailHandler } from '~/shared/classes/detail.handler';

@Component({
  selector: 'app-card-detail',
  template: `
    <crm-form
      [data]="handler.data()"
      [provider]="provider"
      [mode]="handler.mode()"
      (formInitialized)="handler.setForm($event.form)"
    ></crm-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CrmFormComponent],
})
export class CardDetailComponent {
  readonly handler!: DetailHandler<unknown, unknown>;
  protected provider!: CrmFormProvider<unknown>;
}
